import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../../services/tealium/dist/es/types/shared/products.js';
import '../../services/tealium/dist/es/events/event-properties-provider.js';
import { useDispatchTrackErrorEvent } from '../../services/tealium/dist/es/events/use-track-error-event.js';
import { CREATE_APPLE_PAY_SESSION } from '../../operations/mutations/create-apple-pay-session.js';

const useCreateApplePaySession = ()=>{
    var ref2;
    const dispatchTrackErrorEvent = useDispatchTrackErrorEvent();
    const { getLabel  } = useIntl();
    const [mutationCallback, mutation] = useMutation(CREATE_APPLE_PAY_SESSION);
    const Error_Label = getLabel('checkout.express.apple.pay.errors.failed');
    // The domainName should be always determined likes this. Therefore exposing it as a variable is unnecessary.
    const domainName = typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : (ref2 = window.location) === null || ref2 === void 0 ? void 0 : ref2.hostname);
    const createApplePaySession = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(session) {
            return yield mutationCallback({
                variables: {
                    applePaySessionInput: {
                        domainName
                    }
                }
            }).then((response)=>{
                var ref, ref1;
                const merchantSessionData = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.createApplePaySession) === null || ref1 === void 0 ? void 0 : ref1.data;
                if (session && merchantSessionData) {
                    const decodedMerchantSession = atob(merchantSessionData);
                    const decodedAndParsedMerchantSession = JSON.parse(decodedMerchantSession);
                    try {
                        session.completeMerchantValidation(decodedAndParsedMerchantSession);
                    } catch (e) {
                        // Swallow InvalidAccessError
                        if (!(e instanceof Error && e.name === 'InvalidAccessError')) {
                            console.error(e);
                            toast.failed('checkout.express.apple.pay.errors.failed');
                            dispatchTrackErrorEvent(()=>Promise.resolve({
                                    Error_Source: 'Server',
                                    Error_Code: 'Create apple pay session error',
                                    Error_Details: Error_Label,
                                    Error_Message: e instanceof Error ? e.message : ''
                                })
                            );
                            session.abort();
                        }
                    }
                }
            }).catch((error)=>{
                console.error('useCreateApplePaySession: createApplePaySession error', error);
                toast.failed('checkout.express.apple.pay.errors.failed');
                dispatchTrackErrorEvent(()=>Promise.resolve({
                        Error_Source: 'Server',
                        Error_Code: 'Create apple pay session error',
                        Error_Details: Error_Label,
                        Error_Message: error instanceof Error ? error.message : ''
                    })
                );
                session.abort();
            });
        });
        return function(session) {
            return _ref.apply(this, arguments);
        };
    }(), [
        Error_Label,
        dispatchTrackErrorEvent,
        domainName,
        mutationCallback
    ]);
    return {
        createApplePaySession,
        isLoading: mutation.loading,
        updateError: mutation.error
    };
};

export { useCreateApplePaySession };
//# sourceMappingURL=use-create-apple-pay-session.js.map
